// Payment is independent of preparation and collection. Delivered orders must
// not consume the query limit.
export const fulfillmentFilters = ({ kitchen = false } = {}) => [
    ["status", "in", ["Attending", "Invoiced"]],
    ["docstatus", "!=", 2],
    ["customer_delivered_at", "is", "not set"],
    ...(kitchen ? [["food_ready_time", "is", "not set"]] : []),
];
